import { useNavigate } from "react-router-dom";
import "../../css/pages/homePage.css";
import "../../css/pages/aboutUsPage.css";

import Hero from "../designSystem/Hero";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import ContactUsPage from "./ContactUsPage";

import AboutHeroImage from "../../assets/images/AboutUs1.jpg";
import OverviewImage from "../../assets/images/AboutUs2.jpg";
import AnnieImage from "../../assets/images/AboutUs3.jpg";
import NickImage from "../../assets/images/AboutUs4.jpg";

import { ReactComponent as IndependentIcon } from "../../assets/icons/Investments.svg";
import { ReactComponent as AccessibleIcon } from "../../assets/icons/Pensions.svg";
import { ReactComponent as LastingIcon } from "../../assets/icons/Protection.svg";

const AboutUsPage = () => {
  const navigate = useNavigate();

  const approachItems = [
    {
      title: "Independent",
      text: "Clear, honest advice with fully tailored recommendations.",
      icon: <IndependentIcon />,
    },
    {
      title: "Accessible",
      text: "Simple, straightforward advice that helps you feel in control.",
      icon: <AccessibleIcon />,
    },
    {
      title: "Lasting Value",
      text: "Advice and relationships built around your future goals.",
      icon: <LastingIcon />,
    },
  ];

  return (
    <div className="home-page about-page">
      <Hero
        title="Clear financial advice you can trust"
        subtitle="About Us"
        primary={true}
        backgroundImage={AboutHeroImage}
        titleAlign="center"
        subtitleAlign="center"
      />

      <section className="home-about-section">
        <div className="home-container about-grid">
          <div className="about-content">
            <div className="nav primary">About Us</div>

            <h2 className="secondary">
              Our <span className="italic-text">Passion</span>
            </h2>

            <div className="small-divider" />

            <div className="content-semibold primary">
              We help individuals, families and businesses make confident
              decisions about their financial future.
            </div>

            <div className="content primary">
              At FG Wealth Advisory, we provide straightforward, personalised
              advice across pensions, investments and insurance. Our focus is on
              understanding what matters most to you and delivering clear
              guidance to help you grow, protect and manage your wealth over the
              long term.
            </div>
          </div>

          <div className="about-image-wrap">
            <img src={OverviewImage} alt="Family enjoying time outdoors" />
          </div>
        </div>
      </section>

      <section className="services-section about-approach-section">
        <div className="home-container">
          <div className="services-heading">
            <div className="nav">Approach</div>

            <h2>
              Our <span className="italic-text">Approach</span>
            </h2>

            <div className="services-divider" />
          </div>

          <div className="services-grid approach-grid">
            {approachItems.map((item) => (
              <div className="service-card approach-card" key={item.title}>
                <div className="service-icon">{item.icon}</div>

                <h3>{item.title}</h3>

                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="team-section">
        <div className="home-container">
          <div className="team-row">
            <div className="team-content">
              <div className="nav primary">Meet The Team</div>

              <h2 className="secondary">
                Anny <span className="italic-text">Lian-Green</span>
              </h2>
              <div className="small-divider" />

              <p className="content-semibold primary">
                Managing Director | Columbus Fifty Six Limited
              </p>

              <div className="content primary">
                A former banker, I bridge the gap between financial advisor and
                finance director supporting business owners, individuals and
                families, helping plan personal and business finances. My
                holistic approach considers every aspect which might impact you
                financially, in turn providing you peace of mind whilst helping
                you prosper and grow.
              </div>
              <div className="content primary">
                As a business woman, I help empower females through different
                stages of their life, such as getting married, starting a
                family, divorce and planning for retirement. I bring
                non-judgemental ethos and empathy to you. Above all, I value
                trust, integrity and compassion supporting my clients along
                their journey toward financial independence and security.
              </div>
            </div>

            <div className="team-image-wrap">
              <img src={AnnieImage} alt="Annie Lian" />
            </div>
          </div>
        </div>
      </section>

      <section className="team-section team-section-gray">
        <div className="home-container">
          <div className="team-row team-row-reverse">
            <div className="team-content">
              <div className="nav primary">Meet The Team</div>

              <h2 className="secondary">
                Nick <span className="italic-text">Green</span>
              </h2>
              <div className="small-divider" />

              <p className="content-semibold primary">
                Non Executive Director | Columbus Fifty Six Limited
              </p>

              <div className="content primary">
                Nick has worked in Financial Services for over twenty five years
                forging a career advising people. Prior to helping co-found
                FatGreen Wealth, Nick was Franchise Director for a well known UK
                Insurance firm focused on Yorkshire and the North.
              </div>
              <div className="content primary">
                Beyond Insurance, Nick has extensive Financial Services contacts
                across the UK. As many contacts are in Private Equity, Corporate
                Finance and Tax, Nick frequently acts as a conduit for early
                stage and high growth companies seeking to raise finance. Nick
                prides himself on helping individuals, families and their
                businesses prosper and grow.
              </div>
            </div>

            <div className="team-image-wrap">
              <img src={NickImage} alt="Nick Green" />
            </div>
          </div>
        </div>
      </section>
      <ContactUsPage />
    </div>
  );
};

export default AboutUsPage;
